import { FieldType, FormlyFieldConfig } from "@ngx-formly/core";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { SearchService } from "../providers/search-service/search-service";
import { AppService } from "../app.service";
import { AddContractorComponent } from "../components/bog_tour/add-contractor/add-contractor.component";
import { Component, OnInit, ChangeDetectorRef, NgZone } from "@angular/core";
import * as moment from "moment";

import {
  InfiniteScrollCustomEvent,
  ModalController,
  NavController,
  PopoverController,
} from "@ionic/angular";
import { Item } from "firebase/analytics";
import { FormGroup } from "@angular/forms";
import { AppConstants } from "../providers/constants/app-constants.service";
import { BaseInjectorService } from "../base/base-service.injector";
import { LhStorageService } from "@hssa-itasia/ngx-util-core";
import { RapidtourService } from "../services/rapid-tour/rapidtour.service";
import { IDiscussedUserListComponent } from "./rapid-component/i-discussed-user-list/i-discussed-user-list.component";
import * as _ from "lodash";
import { VpcHazService } from "../pages/vpc-haz/vpc-haz.service";
import { SearchUsersComponent } from "./search-users/search-users.component";
import { ModalCommunicationService } from "src/app/services/modal-communication.service";
@Component({
  selector: "i-discussed-user",
  styles: [
    `
      .without_email_ {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .user_name {
        display: block;
        text-align: left;
        font-size: 16px;
        letter-spacing: 0.51px;
        color: #000000;
        opacity: 1;
      }
      .user_email {
        display: block;
        word-break: break-all;
        text-align: left;
        font-size: 12px;
        letter-spacing: 0.38px;
        color: #000000;
        opacity: 1;
      }
      .textBox {
        max-width: 100%;
        width: 100%;
        margin-top: 10px;
      }
      .mandatory {
        color: red;
        font-size: 15px;
      }
      .UserRow {
        display: flex;
        margin-top: 5px;
      }
      .userNameCol {
        display: grid;
        position: relative;
      }

      .userphotoList_col {
        max-width: 45px;
      }
      .userInfoList_col {
        padding-top: 7px !important;
      }
      .userselecttion_col {
        max-width: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .emailCss {
        font-size: 12px;
        display: block;
        position: relative;
        margin-top: 2px;
        text-align: left;
        letter-spacing: 0.38px;
        color: #000000;
        opacity: 1;
      }
      .unselected_css {
        height: 20px;
        width: 20px;
        float: right;
        margin-top: 11px;
        border: 1px solid var(--ion-Teal-color);
        border-radius: 4px;
      }
      .selected_css {
        height: 21px;
        width: 21px;
        float: right;
        margin-top: 11px;
        border-radius: 4px;
        background-color: var(--ion-Teal-color);
        text-align: center;
        ion-icon {
          color: var(--ion-white-color);
          font-size: 19px;
          margin-bottom: 4px;
        }
      }
      .dummyUser_css {
        border-radius: 50%;
        overflow: hidden;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        width: 40px;
        margin-left: -4px;
      }
      .nameCss {
        font-size: 16px;
        display: block;
        position: relative;
        text-align: left;
        letter-spacing: 0.51px;
        color: #000000;
        opacity: 1;
      }
      .searchList_Div {
        height: 100px;
        color: #000;
      }
      .emp_type {
        border-radius: 4px;
        opacity: 1;
        padding: 5px;
        word-break: break-all;
        font-size: 12px;
      }
      .employee_css {
        background: #d6f4f1 0% 0% no-repeat padding-box;
        color: #007382;
      }
      .contractor_css {
        background: #c6f2ff 0% 0% no-repeat padding-box;
        color: #2674d1;
      }
      .not_found_css {
        text-align: left;
        font-size: 16px;
        letter-spacing: 0.51px;
        color: #000000;
        font-weight: 100;
      }
      .searchUser_css {
        text-align: left;
        font-size: 16px;
        letter-spacing: 0.51px;
        color: #000000;
        font-weight: bold;
        margin-left: 5px;
      }
      .addContractor_btn_css {
        border: 1px solid #027382;
        border-radius: 40px;
        opacity: 1;
        height: 40px;
        text-align: left;
        font-size: 16px;
        letter-spacing: 0.51px;
        color: #017180;
        opacity: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 5px;
      }
      .no_display_css {
        display: none;
      }
      .display_css {
        display: block;
        position: relative;
      }
      .email_col {
        display: flex;
        vertical-align: middle;
        position: relative;
        margin: 0 auto;
      }
      .email_col_div {
        display: block;
      }
      .search_icon {
        color: #007382;
        font-size: 25px;
        margin-right: 10px;
      }
      .notes_div {
        width: 27px;
        height: 27px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #027382;
        border-radius: 6px;
        opacity: 1;
      }
      .notes_col {
        width: 36px;
        max-width: 36px;
      }
      .notes_icon {
        font-size: 20px;
        color: var(--ion-color-secondary);
      }
      .user_type_span {
        padding: 1px 4px;
        font-size: 16px;
        border-radius: 2px;
      }

      .cancelBtn {
        height: 48px;
        border: 1px solid #027382;
        border-radius: 40px;
        opacity: 1;
        background: #fff;
        padding: 0 30px;
        color: #017180;
      }
      .saveBtn {
        height: 48px;
        background: #027382;
        border: 1px solid #027382;
        border-radius: 40px;
        opacity: 1;
        padding: 0 30px;
        color: #fff;
      }
      .add_action_btn_col {
        display: flex;
        justify-content: right;
      }
      .description_div {
        text-align: left;
        font-size: 16px;
        letter-spacing: 0.15px;
        color: #000000;
        opacity: 1;
      }
      .description_date_div {
        text-align: left;
        font-size: 12px;
        letter-spacing: 0.38px;
        color: #000000ab;
        opacity: 1;
      }
      .close_icon {
        font-size: 20px;
        color: #000;
        font-weight: bold;
      }
      .close_icon_col {
        max-width: 40px;
        width: 40px;
      }
      .selected_user_row {
        border-radius: 10px;
        display: block;
        border: 1px solid #007382;
        margin-bottom: 5px;
      }
      .disableBtn {
        pointer-events: none;
        opacity: 0.4;
      }

      .full-width {
        width: 100%;
      }

      .chip-input {
        display: inline-flex;
        align-items: center;
        background: #f2f2f2;
        border-radius: 20px;
        padding: 4px 10px;
        gap: 6px;
        min-height: 32px;
        cursor: pointer;
      }

      .chip-input .name {
        font-size: 14px;
        font-weight: 500;
      }

      .recommended-chip {
        background: #555;
        color: #fff;
        border-radius: 12px;
        padding: 2px 8px;
        font-size: 12px;
        font-weight: 500;
        white-space: nowrap;
      }

      .close-icon {
        font-size: 16px;
        cursor: pointer;
      }

      .visibleHide {
        visibility: hidden;
        position: absolute;
      }
    `,
  ],
  template: `
    <div *ngIf="to.source == 'VPC_ADD' && to.type == 'search'">
      <ion-row>
        <ion-col class="i_discussed_label">
          {{ to.title | translate }}
          <span *ngIf="to.required" class="mandatory">*</span>
        </ion-col>
      </ion-row>
      
      <!-- Display selected users as chips -->
      <ion-row *ngIf="selected_users.length > 0">
        <ion-col>
          <div style="display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 10px;">
            <div class="chip-input" *ngFor="let user of selected_users; let i = index" style="margin: 4px 0;">
              <span class="name">{{ user.Full_Name || user.full_name || ((user.Fname || user.first_name || user.First_Name || '') + ' ' + (user.Lname || user.last_name || user.Last_Name || '')).trim() || user.Email }}</span>
              <ion-icon
                name="close"
                class="close-icon"
                (click)="removeUserFromList(user, $event)"
              />
            </div>
          </div>
        </ion-col>
      </ion-row>
      
      <!-- Input field for adding more users (only if less than max) -->
      <ion-row *ngIf="selected_users.length < MAX_SELECTED_USERS">
        <ion-col>
          <mat-form-field
            appearance="outline"
            class="textBox full-width"
            (click)="openGADListComponent($event)"
          >
            <mat-label>{{ to.subtitle | translate }} {{ selected_users.length > 0 ? '(' + selected_users.length + '/' + MAX_SELECTED_USERS + ')' : '' }}</mat-label>
            <!-- Hidden input to satisfy mat-form-field requirements -->
            <input
              matInput
              readonly
              tabindex="-1"
              [value]="''"
              style="position: absolute; opacity: 0; pointer-events: none;"
            />
            <ion-icon matSuffix class="search_icon" name="search-outline" />
          </mat-form-field>
        </ion-col>
      </ion-row>
      
      <!-- Show message when max users reached -->
      <ion-row *ngIf="selected_users.length >= MAX_SELECTED_USERS">
        <ion-col>
          <div style="color: #666; font-size: 12px; margin-top: 5px;">
            Maximum {{ MAX_SELECTED_USERS }} users selected
          </div>
        </ion-col>
      </ion-row>

      <div
        class="searchList_Div"
        [ngStyle]="{ height: searchListHeight }"
        *ngIf="searchTerm != '' && searchUsersList.length > 0"
      >
        <cdk-virtual-scroll-viewport
          class="ion-content-scroll-host"
          [itemSize]="10"
        >
          <div *cdkVirtualFor="let user of searchUsersList">
            <ion-row class="UserRow" (click)="selectedUser(user)">
              <ion-col class="userphotoList_col">
                <ion-icon
                  *ngIf="!user.profile_image"
                  class="dummyUser_css"
                  name="person-circle-outline"
                  style="color:#007382;"
                ></ion-icon>
                <img
                  *ngIf="user.profile_image"
                  class="dummyUser_css"
                  src="{{ user.profile_image }}"
                />
              </ion-col>
              <ion-col class="email_col">
                <div
                  class=""
                  [ngClass]="
                    user.email_hide ? 'without_email_' : 'email_col_div'
                  "
                >
                  <div
                    class="user_name"
                    [ngClass]="user.email_hide ? 'without_email_' : ''"
                  >
                    {{ user.Full_Name || user.full_name || ((user.Fname || user.first_name || user.First_Name || '') + ' ' + (user.Lname || user.last_name || user.Last_Name || '')).trim() || user.Email }}
                  </div>
                  <div class="user_email" *ngIf="!user.email_hide">
                    {{ user.Email }}
                  </div>
                </div>
              </ion-col>
              <ion-col class="userselecttion_col">
                <div
                  *ngIf="user.relation == 'Employee'"
                  class="emp_type employee_css"
                >
                  {{ "SHIELD.I_DISCUSSED_USER.EMPLOYEE" | translate }}
                </div>
                <div
                  *ngIf="user.relation != 'Employee'"
                  class="emp_type employee_css"
                >
                  {{ "SHIELD.I_DISCUSSED_USER.CONTRACTOR" | translate }}
                </div>
              </ion-col>
            </ion-row>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>

      <div *ngIf="searchTerm != '' && searchUsersList.length == 0">
        <ion-row>
          <ion-col>
            <div class="searchUser_css">
              {{ searchTerm }} <span class="not_found_css">,Not Found</span>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-buttons
              class="addContractor_btn_css"
              (click)="addContractor()"
            >
              Add user
            </ion-buttons>
          </ion-col>
          <ion-col> </ion-col>
        </ion-row>
      </div>
    </div>
  `,
  standalone: false
})
export class IDiscussedFormlyType extends FieldType {
  i_discussed_descr_Form: any = new FormGroup({});
  i_discussed_descr_fields: FormlyFieldConfig[] = [
    {
      key: "description",
      type: "textarea",
      className: "treasure-hunt-custom-add-action-description",
      props: {
        label: "VPC.FORM_DESC",
        required: true,
        maxLength: 2000,
        rows: 3,
        appearance: "outline",
      },
    },
  ];
  searchControl = new Subject<string>();
  searchUser: any;
  searchUsersList: any;
  searchTerm: any = "";
  searchListHeight: string = "100px";
  selected_users: any[] = []; // Array for multiple users
  isSelected: boolean = false;
  isDescriptionSave: boolean = false;
  placeHolder: any;
  level: string = "immediate_risk";
  userEdit: boolean = true;
  copyUserList: any = [];
  siteManager: any = {};
  category: string;
  areaOwner: any = {};
  MAX_SELECTED_USERS = 5; // Maximum users allowed
  private isModalOpening = false; // Prevent double-trigger

  areaOwnerInfo: any = {
    id: "",
    full_name_lower: "",
    Email: "",
    Full_Name: "",
    First_Name: "",
    Last_Name: "",
  };
  editObservation: any;

  constructor(
    public vpcHazService: VpcHazService,
    public ngZone: NgZone,
    private rapidService: RapidtourService,
    private changeDetection: ChangeDetectorRef,
    private modal: ModalController,
    private searchService: SearchService,
    private appService: AppService,
    private lhStorage: LhStorageService,
    private modalCommunicationService: ModalCommunicationService
  ) {
    super();
    this.selected_users = [];
  }
  keyDownFunction(event: any) {
    this.searchControl.next(event);
  }
  async setSearchedPolicy(searchText) {
    this.searchUsersList = [];
    this.searchTerm = "";
    if (searchText != "") {
      this.searchTerm = searchText;
      const query = this.searchTerm.toLowerCase(); // Get the search query
      let updatedUsers = this.copyUserList.filter((item) => {
        return (
          item.Email.toLowerCase().includes(query) ||
          item.full_name_lower.toLowerCase().includes(query)
        );
      });
      this.searchUsersList = updatedUsers;
      if (this.searchUsersList.length == 1) this.searchListHeight = "100px";
      else if (this.searchUsersList.length == 2)
        this.searchListHeight = "130px";
      else if (this.searchUsersList.length > 2) this.searchListHeight = "190px";
    }
    this.changeDetection.detectChanges();
  }
  async setGAD_Employees() {
    let tmp_GAD_emp_list = await this.lhStorage.get("GAD_employee_list");
    let shield_info = await this.lhStorage.get("currentRapid");
    let filtered = tmp_GAD_emp_list.filter(
      (obj: any) => obj.country == shield_info.country
    );
    let usersList = filtered[0].GAD_employee_list.filter(
      (obj: any) => obj.full_name_lower != undefined
    );
    this.searchUsersList = usersList.sort((a, b) =>
      a.Email.localeCompare(b.Email)
    );
    this.copyUserList = usersList.sort((a, b) =>
      a.Email.localeCompare(b.Email)
    );
    this.searchService.item = this.searchUsersList;

    // this.searchUsersList =[];
    this.isSelected = false;
    this.isDescriptionSave = false;
  }

  async ngOnInit() {

    let shield_info = await this.lhStorage.get("currentRapid");

    let subscribtion = this.appService.riskLevelSubject.subscribe(
      (res: any) => {
        this.level = res;
      }
    );

    this.setSearchedPolicy("");
    this.searchControl
      .pipe(debounceTime(700), distinctUntilChanged())
      .subscribe((searchText) => {
        this.setSearchedPolicy(searchText);
      });

    // Subscribe to modal communication service
    this.modalCommunicationService.searchUserLists$.subscribe(() => {
      this.searchUserLists();
    });

    let editObservation = await this.lhStorage.get("editObservation");
    this.editObservation=editObservation;
    if (this.vpcHazService.shield_obs_fromRoute == "action-management") {
      let editObservationDetail = editObservation.currentObservationInfo;
      if (Array.isArray(editObservationDetail.i_discussed_user)) {
        this.selected_users = editObservationDetail.i_discussed_user;
        if (this.selected_users.length > 0) {
          this.areaOwner = this.selected_users[0];
        }
      }
    } else {
      this.setGAD_Employees();

      if (editObservation != null || editObservation != undefined) {
        this.siteManager = {
          Email: editObservation?.site_manager_email,
          Full_Name: editObservation?.site_manager_name,
        };
        this.areaOwnerInfo.id =
          editObservation?.currentObservationInfo.i_discussed_user?.id;
        this.areaOwnerInfo.full_name_lower =
          editObservation?.currentObservationInfo.i_discussed_user?.full_name_lower;
        this.areaOwnerInfo.Email =
          editObservation?.currentObservationInfo.i_discussed_user?.Email;
        this.areaOwnerInfo.Full_Name =
          editObservation?.currentObservationInfo.i_discussed_user?.Full_Name;
        this.areaOwnerInfo.First_Name =
          editObservation?.currentObservationInfo.i_discussed_user?.First_Name;
        this.areaOwnerInfo.Last_Name =
          editObservation?.currentObservationInfo.i_discussed_user?.Last_Name;
        this.areaOwner = this.areaOwnerInfo;

        let data: any = editObservation.currentObservationInfo;
        setTimeout(() => {
          if (data?.i_discussed_user) {
            if (Object.keys(data.i_discussed_user).length == 0) {
              this.selected_users = [];
            } else {
              this.userEdit = false;
              this.isSelected = true;
              let tmp_selected_user = data?.i_discussed_user;
              if (Array.isArray(tmp_selected_user)) {
                // Handle array of users
                this.selected_users = tmp_selected_user;
                this.selected_users.forEach((docData) => {
                  docData.email_hide = false;
                  if (docData.Email && docData.Email.includes("@nonboguser.com"))
                    docData.email_hide = true;
                });
                // Set first user as areaOwner
                if (this.selected_users.length > 0) {
                  this.areaOwner = this.selected_users[0];
                }
              } else {
                // Handle single user (backward compatibility)
                if ("email" in tmp_selected_user) {
                  tmp_selected_user.Email = tmp_selected_user.email;
                  tmp_selected_user.Full_Name = tmp_selected_user.full_name;
                }
                this.selected_users = [tmp_selected_user];
                this.areaOwner = tmp_selected_user;
              }
              this.changeDetection.detectChanges();
            }
          }
        }, 1000);
      } else {
        this.siteManager = {
          Email: shield_info.site_manager_email,
          Full_Name: shield_info?.site_manager_name || "",
        };

        // this.areaOwnerInfo.id =
        //   this.appService.currentTour.currentBogTourInfo.area_owner_email;
        // this.areaOwnerInfo.full_name_lower =
        //   this.appService.currentTour.currentBogTourInfo.area_owner.toLowerCase();
        // this.areaOwnerInfo.Email =
        //   this.appService.currentTour.currentBogTourInfo.area_owner_email;
        // this.areaOwnerInfo.Full_Name =
        //   this.appService.currentTour.currentBogTourInfo.area_owner;
        // this.areaOwnerInfo.First_Name =
        //   this.appService.currentTour.currentBogTourInfo.area_owner.split(
        //     " "
        //   )[0];
        // this.areaOwnerInfo.Last_Name =
        //   this.appService.currentTour.currentBogTourInfo.area_owner.split(
        //     " "
        //   )[1];
        // this.areaOwner = this.areaOwnerInfo;
      }
    }

    // ✅ Ensure Full_Name is patched into input as soon as areaOwner is set
    // if (this.areaOwner?.Full_Name) {
    //   this.formControl.setValue(this.areaOwner);
    //   this.changeDetection.detectChanges();
    // }

    // Set form control value
    if (this.selected_users.length > 0) {
      this.ngZone.run(() => {
        this.formControl.setValue(this.selected_users);
        this.formControl.markAsTouched();
        this.formControl.markAsDirty();
        this.formControl.updateValueAndValidity({ emitEvent: true });
        this.form.updateValueAndValidity({ emitEvent: true });
        this.changeDetection.detectChanges();
      });
    } else if (this.areaOwner?.Full_Name) {
      this.ngZone.run(() => {
        this.formControl.setValue(this.areaOwner);
        this.formControl.markAsTouched();
        this.formControl.markAsDirty();
        this.formControl.updateValueAndValidity({ emitEvent: true });
        this.form.updateValueAndValidity({ emitEvent: true });
        this.changeDetection.detectChanges();
      });
    }
  }

  clearAreaOwner(event: Event) {
    event.stopPropagation(); // don't trigger openGADListComponent
    this.areaOwner = null;
    this.isSelected = false;
    this.selected_users = []; // Clear the array

    // Clear the form control properly
    this.formControl.patchValue([]);
    this.formControl.markAsTouched();
    this.changeDetection.detectChanges();
  }

  async openGADListComponent(event?: any) {
    // Prevent event bubbling
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    // Prevent double-trigger
    if (this.isModalOpening || this.vpcHazService.viewOnly) return;

    this.isModalOpening = true;
    let zoneOwner:any;
    console.log("current tour=",this.appService.currentTour);
    if(Object.keys(this.appService.currentTour).length>0){
      zoneOwner=this.appService.appData.configuredZone.find(item=>item.id===this.appService.currentTour.currentBogTourInfo.zone);
      console.log("zoneOwner=",zoneOwner); 
      this.appService.currentTour.currentBogTourInfo.zoneConfiguration=zoneOwner;

    }else{
      console.log("this.editObervation=",this.editObservation);
      this.appService.currentTour.currentBogTourInfo=this.editObservation.currentObservationInfo;
      zoneOwner=this.appService.appData.configuredZone.find(item=>item.id===this.appService.currentTour.currentBogTourInfo.zone);
      console.log("zoneOwner=",zoneOwner); 
      this.appService.currentTour.currentBogTourInfo.zoneConfiguration=zoneOwner;
    }
    const modal = await this.modal.create({
      component: IDiscussedUserListComponent,
      // Use a new, dedicated CSS class for this modal's style
      cssClass: "half-page-modal",
      backdropDismiss: false,
      componentProps: {
        site_manager: this.appService.appData.site_manager_info[0],
        area_owner: zoneOwner,
        // Pass callback function to handle searchUserLists call
        onSearchUserLists: () => {
          this.searchUserLists();
        },
        category: 'add-discussed-user'
      },
      // ⭐ Add these two properties for the sheet modal behavior ⭐
      // initialBreakpoint: 0.5,
      // breakpoints: [0, 0.5, 1],
    });

    await modal.present();
    const response = await modal.onDidDismiss();

    if (response?.data?.status == "ok") {
      const res = response?.data?.data;
      console.log('User selected from modal:', res);

      // Wait a tick for modal to fully dismiss before updating UI
      setTimeout(async () => {
        this.addUserToSelection(res);
        await this.pushNewUserToStorage(res);
        await this.setLastFiveDiscussedUser(res);
      }, 100);
    } else if (response?.data?.status == "searchUser") {
      // this.searchUserLists();
    }

    // Reset flag after modal dismisses
    setTimeout(() => {
      this.isModalOpening = false;
    }, 300);
  }

  async searchUserLists() {
    const searchmodal = await this.modal.create({
      component: SearchUsersComponent,
      backdropDismiss: false,
      componentProps: {
        fromAction: "add-discussed-user",
        usersValues: {},
        selectedUsers: this.selected_users
      },
      // initialBreakpoint: 0.7,
      // breakpoints: [0, 0.7, 1],
    });

    await searchmodal.present();
    let response = await searchmodal.onDidDismiss();
    console.log('Search modal dismissed with response:', response);

    if (response?.data?.status == "ok") {
      const res = response?.data?.data;
      console.log('User selected from search modal:', res);

      // Wait a tick for modal to fully dismiss before updating UI
      setTimeout(async () => {
        this.addUserToSelection(res);
        await this.setLastFiveDiscussedUser(res);
      }, 100);
    } else if (response?.data?.status == "add_user") {
      this.addContractor();
    }
  }

  async setLastFiveDiscussedUser(usr) {
    let lastFiveDiscusedUserList = await this.lhStorage.get(
      "lastFiveIDiscussedUsers"
    );
    let userArray = lastFiveDiscusedUserList ? lastFiveDiscusedUserList : [];
    const checkIfExists = _.filter(userArray, (u: any) => {
      return u.Email === usr.Email;
    });
    if (userArray.length == 5) {
      if (checkIfExists.length == 0) {
        userArray.splice(0, 1);
      }
    }
    if (checkIfExists.length == 0) {
      userArray.push(usr);
    }
    let finaluserArray = _.uniqBy(userArray, "Email");
    await this.lhStorage.set("lastFiveIDiscussedUsers", finaluserArray);
  }
  async addContractor() {
    const modal = await this.modal.create({
      component: AddContractorComponent,
      cssClass: "add_contractor_popup_css",
      backdropDismiss: true,
      componentProps: {},
      // initialBreakpoint: 0.7,
      // breakpoints: [0, 0.7, 1],
    });
    await modal.present();
    let response = await modal.onDidDismiss();
    if (response?.data?.data) {
      this.searchUser = "";
      let res = response?.data?.data;
      this.pushNewUserToStorage(res);
      this.selectedUser(res);
      this.setLastFiveDiscussedUser(res);
    }
  }
  async pushNewUserToStorage(new_user) {
    let tmp_GAD_emp_list = await this.lhStorage.get("GAD_employee_list");
    let shield_info = await this.lhStorage.get("currentRapid");
    let index = tmp_GAD_emp_list.findIndex(
      (obj: any) => obj.country == shield_info.country
    );
    tmp_GAD_emp_list[index].GAD_employee_list = [
      ...tmp_GAD_emp_list[index].GAD_employee_list,
      new_user,
    ];
    let usersList = tmp_GAD_emp_list[index].GAD_employee_list;
    tmp_GAD_emp_list[index].GAD_employee_list = usersList;
    await this.lhStorage.set("GAD_employee_list", tmp_GAD_emp_list);
    this.setGAD_Employees();
  }
  selectedUser(item) {
    this.addUserToSelection(item);
  }

  addUserToSelection(item) {
    // Check if already at max capacity
    if (this.selected_users.length >= this.MAX_SELECTED_USERS) {
      console.log(`Maximum ${this.MAX_SELECTED_USERS} users can be selected`);
      return;
    }

    // Check if user already exists
    const existingUser = this.selected_users.find(
      (u: any) => u.Email === item.Email || u.id === item.id
    );

    if (existingUser) {
      console.log('User already selected');
      return;
    }

    let fullName='';
    let firstName=item.First_Name || item.first_name || item.Fname;
    let lastName=item.Last_Name || item.last_name || item.Lname;
    fullName=firstName+ " "+lastName;
    console.log("full name=",fullName);
    // Create user object
    const userObj = {
      id: item.id || item.Email,
      Email: item.Email || item.id,
      Full_Name: fullName,//item.Full_Name || `${item.first_name} ${item.last_name}` || `${item.Fname} ${item.Lname}`,
      First_Name: item.First_Name || item.first_name || item.Fname,
      Last_Name: item.Last_Name || item.last_name || item.Lname,
      full_name_lower: (item.Full_Name || `${item.first_name} ${item.last_name}`).toString().toLowerCase(),
      ...item
    };

    // Add to array
    this.selected_users.push(userObj);

    // Set first user as areaOwner for backward compatibility
    if (this.selected_users.length === 1) {
      this.areaOwner = userObj;
    }

    this.searchTerm = "";
    this.searchUsersList = [];
    this.searchUser = "";
    this.isSelected = true;

    // Update form control with the array of users
    this.formControl.setValue(this.selected_users);
    this.formControl.markAsTouched();
    this.formControl.markAsDirty();
    this.formControl.updateValueAndValidity({ emitEvent: true });

    console.log('Selected users:', this.selected_users);
    console.log('Form control value after update:', this.formControl.value);
  }

  removeUserFromList(user, event) {
    event.stopPropagation();

    // Remove user from array
    this.selected_users = this.selected_users.filter(
      (u: any) => u.Email !== user.Email && u.id !== user.id
    );

    // Update areaOwner if we have users left
    if (this.selected_users.length > 0) {
      this.areaOwner = this.selected_users[0];
    } else {
      this.areaOwner = null;
    }

    // Update form control
    this.formControl.patchValue(this.selected_users);
    this.formControl.markAsTouched();

    this.changeDetection.detectChanges();
  }

  editSelectedUser() {
    if (this.userEdit) this.isSelected = !this.isSelected;
  }
  cacneBnt() {
    this.isDescriptionSave = !this.isDescriptionSave;
  }
}

